<app-global-info
  icon="mdi-account-check-outline"
  [title]="'logout.title' | translate"
  [description]="'logout.text' | translate"
  [showButton]="true"
  [buttonText]="'logout.actions.login' | translate"
  (clicked)="login()"
></app-global-info>
